import getDst from './_getDst';

export default function getValuesDst<
  Target extends Partial<Record<'valuesDst' | 'valuesSrc', string |((props: Record<IdName, number>) => string)>> & Partial<Record<IdName, number>>,
  IdName extends string = 'formId',
>(props: Target, idName = 'formId' as IdName) {
  return getDst('values', props, { idName });
}
